<template>
    <v-container
        fluid
        grid-list-lg
    >
        <v-layout
            row
            wrap
        >
            <v-flex>
                <v-layout
                    align-center
                    justify-center
                    column
                    pb-2
                >
                    <router-link
                        to="/register"
                        class="button"
                    >
                        <!-- <button to="/register" class="button"> -->
                        Join now for free
                        <!-- </button> -->
                    </router-link>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: "HomeRegister"
};
</script>

<style lang="scss" scoped>
.features {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 40px auto 0;
    padding: 0;
    max-width: 1200px;
    list-style: none;

    &__item {
        flex-grow: 1;
        flex-basis: 0;
        margin: 0 10px 30px;
        font-size: 15px;
        font-style: normal;
        font-weight: normal;
        line-height: 1.47;
        text-align: center;
        white-space: nowrap;

        span {
            display: block;
        }

        &:before {
            content: '';
            display: block;
            margin: 0 auto 10px;
            height: 97px;
            width: 97px;
            background-color: rgba(255, 255, 255, 0.75);
            background-position: 50%;
            background-repeat: no-repeat;
            border: 2px solid #fff;
            border-radius: 50%;
        }

        &--villatv:before {
            background-image: url('../assets/sso-icon-set/villatv.png');
            background-size: 64px;
            background-position: 50% 45%;
        }

        &--sso-app:before {
            background-image: url('../assets/sso-icon-set/sso-app.svg');
            background-size: 64px;
            background-position: 50% 45%;
        }

        &--sso-auction-site:before {
            background-image: url('../assets/sso-icon-set/sso-auction-site.svg');
            background-size: 48px;
            background-position: 50% 50%;
        }

        &--sso-club-site:before {
            background-image: url('../assets/sso-icon-set/sso-club-site.svg');
            background-size: 64px;
            background-position: 50% 45%;
        }

        &--sso-click-collect:before {
            background-image: url('../assets/sso-icon-set/sso-click-collect.svg');
            background-size: 48px;
            background-position: 50% 50%;
        }

        &--sso-memberships:before {
            background-image: url('../assets/sso-icon-set/sso-memberships.svg');
            background-size: 64px;
            background-position: 50% 45%;
        }

        &--sso-rewards:before {
            background-image: url('../assets/sso-icon-set/sso-rewards.svg');
            background-size: 48px;
            background-position: 50% 50%;
        }

        &--sso-ticketing:before {
            background-image: url('../assets/sso-icon-set/sso-ticketing.svg');
            background-size: 64px;
            background-position: 50% 45%;
        }

        &--sso-official-store:before {
            background-image: url('../assets/sso-icon-set/sso-official-store.svg');
            background-size: 48px;
            background-position: 50% 50%;
        }
    }
}

.membership-image {
    margin-top: 16px;
    width: 100%;
}
</style>
